import { ENV_DEV } from "../../../utils/window";
import getInitialStyle from "./initials/get-initial-style";
import setInitialProperties from "./set-initial-properties";

/**
 * Get and set the initial values from `getComputedStyle` if no user-defined initial style is provided
 * @param {MainClassProps} main
 * @param {PropertyWrapperProps} data
 * @param {String} name
 */
const setComputedInitialProperties = (main, data, name) => {
  /**
   * Get the computed style of a property
   * @example `background-color` => `rgba(0, 0, 255, 0.667)`
   */
  let initials = main.computedStyle.getPropertyValue(name).trim();

  /**
   * Computed style of "transform" property must always be "none".
   * Otherwise it can return `matrix()` where is hard to read individual properties
   */
  if (name === "transform") {
    initials = "none";
  }

  if (ENV_DEV && name.startsWith("--") && !initials) {
    console.warn(
      `[TorusKit warn]: No initial value for \`${name}\` CSS variable found!`
    );
  }

  /**
   * Get the `name` and `initials` of the parent property "function"
   * @example `background-color` => `{'name' => 'background-color', 'initials' => 'rgba(0▏0▏255▏0.667)'}`
   */
  const processed = getInitialStyle(data, initials);

  /** Empty step, because the initial trigger doesn't have more that one step */
  const step = new Map();

  step.set("original", initials);
  step.set("options", null);
  step.set("properties", new Map());

  setInitialProperties(processed, main, step, true);
};

export default setComputedInitialProperties;
